<template>
  <div>
    <ul class="list-attachment multi-list">
      <li v-for="(_attachment, index) in attachments" :key="index">
        <span class="action-attach" @click="downloadDocument(_attachment)">
          <svgicon :name="setIcon(_attachment)" :original="true"/>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import AttachmentConstants from "@common/constants/AttachmentConstants";
export default {
  props: ['attachments', 'oceanLegAttachmentsMeta'],
  methods: {
    findFileExt(file) {
      if(file.name) {
        const fileName = file.name;
        return fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
      } else {
        const fileName = file.url;
        const index1 = ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        let index2 = fileName.indexOf("?");
        index2 = index2 === -1 ? fileName.length : index2;
        return fileName.slice(index1, index2).toLowerCase();
      }
    },
    setIcon(file) {
      let fileExt = this.findFileExt(file);
      if (AttachmentConstants.images.includes(fileExt)) {
        let IMAGE = file.url;
        return IMAGE;
      } else if (AttachmentConstants.pdf.includes(fileExt)) {
        return 'pdf';
      } else if (AttachmentConstants.excel.includes(fileExt)) {
        return 'excel';
      }
    },
    downloadDocument(file) {
      let fileExt = this.findFileExt(file);
      const bucketName = file.bucket_name;
      const url = file.url;
      const s3File = `${bucketName}:::${url}`
      this.$store.dispatch('order/getPreviewUrl', { params: s3File, fileExt });
    },
  },
};
</script>
